module.exports = __webpack_public_path__ + "static/media/interrogacao.3d793613.svg";